import React, { useEffect, useMemo, useState } from "react";
import { PaginationNormalStyled } from "./styled";
// import cx from 'classnames';
// import ReactPaginate from 'react-paginate';
import { Icons, Inputs } from "components";
import theme from "styles/theme.json";
// import { useRememberFilter } from 'utils/hooks'

const PaginationNormal = ({
  currentPage,
  perPage,
  totalPage,
  fromOrder = 1,
  toOrder = 1,
  onClickPage,
  onChangePerPage,
  widthbox,
  isLoading,
  lastPage,
  isSearchParams = false,
  alwaysShowArrows = false,
  perPageOptions,
}) => {
  const optionsPerPage = perPageOptions?.length > 0 ? perPageOptions : [
    { label: "20", value: 20 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
  ];
  // const customClass = cx({
  //   theme_standard_pagination: theme_standard_pagination,
  // });

  // const { setSearchParams } = useRememberFilter();

  const [_perPage, _setPerPage] = useState(20);
  const [_currentPage, _setCurrentPage] = useState(1);
  const [_heightMenu, _setHeightMenu] = useState("109px");
  const [_topSelect, _setTopSelect] = useState("-110px");
  const [_countPage, _setCountPage] = useState(1);

  const formatNumber = (num) => new Intl.NumberFormat().format(num);

  useMemo(() => {
    if (perPage && perPage !== _perPage) {
      _setPerPage(perPage);
    }

    if (currentPage && currentPage !== _currentPage) {
      _setCurrentPage(currentPage);
    }
  }, [currentPage, perPage, totalPage]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (perPage) {
      _setPerPage(perPage);

      let countPage = Math.ceil(totalPage / perPage);
      _setCountPage(countPage);

      if (countPage <= 1) {
        _setHeightMenu("40px");
        _setTopSelect("-40px");
      } else if (countPage === 2) {
        _setHeightMenu("80");
        _setTopSelect("-73px");
      } else {
        _setHeightMenu("109px");
        _setTopSelect("-110px");
      }
    }
  }, [perPage, totalPage]);

  const _handleSetSearchParams = (e) => {
    if (!isSearchParams) {
      return;
    }
    // setSearchParams(e);
  };

  const _handleChangePerpage = (e) => {
    if (isLoading) {
      return;
    }

    let countPage = Math.ceil(totalPage / e.value);
    _setCountPage(countPage);

    if (countPage <= 1) {
      _setHeightMenu("40px");
      _setTopSelect("-40px");
    } else if (countPage === 2) {
      _setHeightMenu("80");
      _setTopSelect("-73px");
    } else {
      _setHeightMenu("109px");
      _setTopSelect("-110px");
    }

    _setPerPage(e.value);
    _resetPage();
    onChangePerPage(e.value);
    _handleSetSearchParams({ per_page: e.value, current_page: 1 });
  };

  const _handleChangePage = (e) => {
    if (isLoading) {
      return;
    }

    _setCurrentPage(e.value);
    _onClickPage(e.value);
    _handleSetSearchParams({ current_page: e.value });
  };

  const _resetPage = () => {
    if (isLoading) {
      return;
    }

    _setCurrentPage(1);
    _handleSetSearchParams({ current_page: 1 });
  };

  const _renderPageOption = (e) => {
    let _pageNumbers = [];
    for (let i = 1; i <= e; i++) {
      _pageNumbers.push({ label: i, value: i });
    }
    return _pageNumbers;
  };

  const _handleClickBack = () => {
    if (isLoading) {
      return;
    }

    if (_currentPage > 1) {
      const page = _currentPage - 1;
      _setCurrentPage(page);
      _onClickPage(page);
      _handleSetSearchParams({ current_page: page });
    }
  };
  const _handleClickNext = () => {
    if (isLoading) {
      return;
    }

    if (_currentPage < Math.ceil(totalPage / _perPage)) {
      const page = _currentPage + 1;
      _setCurrentPage(page);
      _onClickPage(page);
      _handleSetSearchParams({ current_page: page });
    }
  };

  const _handleClickFirstBack = () => {
    if (isLoading) {
      return;
    }

    _setCurrentPage(1);
    _onClickPage(1);
    _handleSetSearchParams({ current_page: 1 });
  };

  const _handleClickLastNext = () => {
    if (isLoading) {
      return;
    }

    const page = Math.ceil(totalPage / _perPage);
    _setCurrentPage(page);
    _onClickPage(page);
    _handleSetSearchParams({ current_page: page });
  };

  const _onClickPage = (e) => {
    onClickPage && onClickPage(e);
  };

  const canGoPrev = _currentPage >= 2;
  const canGoNext = _currentPage < lastPage;
  const ARROW_ACTIVE = '#575656';
  const ARROW_DISABLED = '#E5E7EB';
  const prevArrowColor = canGoPrev ? ARROW_ACTIVE : ARROW_DISABLED;
  const nextArrowColor = canGoNext ? ARROW_ACTIVE : ARROW_DISABLED;

  return (
    <PaginationNormalStyled>
      <div className="pn_left_col">
        {`แสดง ${fromOrder ? fromOrder : 0} ถึง ${toOrder ? formatNumber(toOrder) : 0
          } จาก ${totalPage ? formatNumber(totalPage) : 1} รายการ`}
        <div className="pn_dropdown_wrap">
          <Inputs.SelectDropdown
            disabled={isLoading}
            arrowColor={theme.COLORS.GRAY_40}
            value={{ label: _perPage, value: _perPage }}
            options={optionsPerPage}
            onChange={_handleChangePerpage}
            topselect={`-${optionsPerPage.length * 36}px`}
            widthbox={widthbox}
          />
        </div>
      </div>
      <div className="pn_right_col">
        {(alwaysShowArrows || canGoPrev) && (
          <>
            <div className="arrow_group" onClick={_handleClickFirstBack}>
              <Icons.IconArrowPagination direction="left" color={prevArrowColor} />
              <Icons.IconArrowPagination direction="left" color={prevArrowColor} />
            </div>
            <div className="arrow_single" onClick={_handleClickBack}>
              <Icons.IconArrowPagination direction="left" color={prevArrowColor} />
            </div>
          </>
        )}
        หน้า
        <div className="pn_dropdown_wrap">
          <Inputs.SelectDropdown
            arrowColor={theme.COLORS.GRAY_40}
            value={{ label: _currentPage, value: _currentPage }}
            options={_renderPageOption(Math.ceil(totalPage / _perPage))}
            onChange={_handleChangePage}
            topselect={_topSelect}
            heightMenu={_heightMenu}
            widthbox={widthbox}
            disabled={!alwaysShowArrows && _countPage < 2}
          />
        </div>
        จาก {totalPage ? formatNumber(Math.ceil(totalPage / _perPage)) : ""}
        {(alwaysShowArrows || canGoNext) && (
          <>
            <div className="arrow_single" onClick={_handleClickNext}>
              <Icons.IconArrowPagination color={nextArrowColor} />
            </div>
            <div className="arrow_group" onClick={_handleClickLastNext}>
              <Icons.IconArrowPagination color={nextArrowColor} />
              <Icons.IconArrowPagination color={nextArrowColor} />
            </div>
          </>
        )}
      </div>
    </PaginationNormalStyled>
  );
};

export default PaginationNormal;
